module.exports = __webpack_public_path__ + "static/img/13.bdb7cdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/13.png
// module id = taIK
// module chunks = 0